import type {
  ClientPreferencesComponentInput,
  ComponentValueResponse,
  SaveComponentValueResponse,
} from "@repo/shared/types";
import { getWithToken, postWithToken } from "../_client";

const BASE = "/public/flow";

export function getPublicClientPreferencesValue(token: string) {
  return getWithToken<ComponentValueResponse>(
    `${BASE}/client-preferences/flow-instance-value`,
    token,
  );
}

export function savePublicClientPreferences(token: string, input: ClientPreferencesComponentInput) {
  return postWithToken<SaveComponentValueResponse>(
    `${BASE}/client-preferences/flow-instance-value`,
    token,
    input satisfies ClientPreferencesComponentInput,
  );
}
